<template>
    <commonModal :show.sync="visibility" isHideFooter :width="width" :styles="{ minHeight:'auto', overflow: 'auto'}">
      <loading :loading="loading" background="transparent" color="#c4332e" style="z-index: 120"></loading>
      <div class="modal-header" slot="header">{{title}}</div>
      <div class="modal-content" :style="styles" v-if="!isHtml">{{ content }}</div>
      <div class="modal-content" :style="styles" v-if="isHtml" v-html="content"></div>
      <div v-if="!isHideFoot" class="modal-footer" slot="footer">
          <div class="modal-btn-ok" @click="onConfirm">确认</div>
          <div class="modal-btn-cancel" @click="onCancel">取消</div>
      </div>
    </commonModal>
</template>

<script>
import commonModal from "components/commonModal/index.vue";
import loading from "components/loading.vue";
export default {
    name: "confirmModal",
    components:{
        commonModal,
        loading
    },
    props:{
        show: {
            type: Boolean,
            default: false,
        },
        width: {
            type: Number,
            default: 450,
        },
        title: {
            type: String,
            default: "",
        },
        content: {
            type: String,
            default: "",
        },
        isHtml: {
            type: Boolean,
            default: false,
        },
        isHideFoot:{
            type: Boolean,
            default: false,
        },
        isLoading: {
            type: Boolean,
            default: false,
        },
    },
    data(){
        return {
            loading: false,
        }
    },
    watch:{
        visibility: {
            deep: true,
            immediate: true,
            handler(value){
                if(this.isLoading){
                    if(!value){
                        this.loading = false;
                    }
                }
                
            }
        }
    },
    computed: {
        visibility: {
            get() {
                return this.show;
            },
            set(val) {
                this.$emit("update:show", val);
            },
        },
        styles(){
            return this.isHideFoot ? { paddingBottom: "30px"} : { paddingBottom: "0px"}
        }
    },
    methods:{
        onConfirm(){
            if(this.isLoading){
                this.loading = true;
            }
            this.$emit("onConfirm");
        },
        onCancel(){
            this.visibility = false;
        }
    },
}
</script>